<template>
  <div class="SMS">
    <div class="SMS-header">
      <div>短信管理</div>
      <el-button @click="$router.go(-1)">返回</el-button>
    </div>
    <div class="SMS-main" v-loading="loading">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleFormRef"
        label-width="80px"
      >
        <el-form-item label="学校">
          <el-radio-group
            v-model="ruleForm.applicableCampus"
            style="display: flex; line-height: 36px"
          >
            <el-radio :label="0" :disabled="!isOperation">全部</el-radio>
            <el-radio :label="1" :disabled="!isOperation">部分</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="ruleForm.applicableCampus ? '应用学校' : '屏蔽学校'"
          :required="ruleForm.applicableCampus ? true : false"
          prop="smsCampus"
        >
          <div style="display: flex; align-items: center">
            <el-select
              style="flex: 1; margin-right: 8px"
              v-model="schoolData"
              filterable
              remote
              reserve-keyword
              placeholder="请输入学校"
              :remote-method="remoteMethod"
              :disabled="!isOperation"
            >
              <el-option
                v-for="(item, index) in schoolList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button @click="onAddSchools" :disabled="!isOperation"
              >添加</el-button
            >
          </div>
          <div class="card-wrap">
            <div
              v-for="item in ruleForm.smsCampus"
              :key="item.value"
              class="dialog-item"
            >
              <span>{{ item.label }}</span>
              <el-button
                type="text"
                icon="circle-close"
                @click="onDelSchools(item.value)"
              ></el-button>
            </div>
          </div>
          <div class="card-footer">
            共计{{ ruleForm.smsCampus.length }}所学校
          </div>
        </el-form-item>
        <el-form-item label="入学年份">
          <el-select
            v-model="ruleForm.caid"
            placeholder="请选择入学年份"
            filterable
            multiple
            :disabled="!isOperation"
          >
            <el-option
              v-for="(item, index) in inYearDataSource"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学生范围">
          <span>共计{{ ruleForm.studentNumber }}位学生</span>
        </el-form-item>
        <el-form-item label="编辑短信" prop="sendMessage">
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="ruleForm.sendMessage"
            :maxlength="64"
            show-word-limit
            :disabled="!isOperation"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right" v-if="isOperation">
        <el-button @click="$router.go(-1)">取消</el-button>
        <el-button type="primary" @click="submitForm">发布</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const validateSchool = (rule, value, callback) => {
      if (this.ruleForm.applicableCampus && (!value || !value.length)) {
        return callback(new Error("校区不能为空"));
      }
      callback();
    };
    return {
      id: "",
      isOperation: true, // 是否可操作
      schoolDataSource: [],
      schoolList: [],
      schoolData: "",
      inYearDataSource: [],
      ruleForm: {
        applicableCampus: 0,
        caid: "",
        sendMessage: "",
        smsCampus: [],
        studentNumber: 0,
      },
      rules: {
        sendMessage: {
          required: true,
          message: "请编辑短信",
          trigger: "blur",
        },
        smsCampus: {
          validator: validateSchool,
          trigger: "change",
        },
      },
      loading: false,
    };
  },
  computed: {
    studentNumber() {
      return {
        unid: this.ruleForm.smsCampus.map((item) => item.value),
        relateState: this.ruleForm.applicableCampus,
        caid:
          this.ruleForm.caid && this.ruleForm.caid.length
            ? this.ruleForm.caid.join(",")
            : "",
      };
    },
  },
  watch: {
    studentNumber: {
      handler: function (value) {
        if (value.caid) {
          this.apiGetStudentNumber(value);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    if (this.$route.query.type === "detail") {
      this.isOperation = false;
    }
  },
  mounted() {
    this.apiGetALLSchool();
    const thisYear = new Date().getFullYear();
    for (let i = 0; i < 10; i++) {
      this.inYearDataSource.push({
        label: thisYear - i,
        value: thisYear - i,
      });
    }
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.apiGetConfig();
    } else {
      this.ruleForm.caid = [thisYear];
    }
  },
  methods: {
    remoteMethod(query) {
      if (query) {
        this.schoolList = this.schoolDataSource.filter((item) => {
          return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else {
        this.schoolList = [];
      }
    },
    apiGetConfig() {
      this.loading = true;
      this.$http({
        url: this.$util.domain + "/adminapi/v1/sms/getConfig",
        method: "POST",
        dataType: "json",
        body: JSON.stringify({
          id: this.id,
        }),
      })
        .then((res) => {
          if (res.body.data && JSON.stringify(res.body.data) !== "{}") {
            this.ruleForm = {
              ...res.body.data,
              smsCampus: res.body.data.smsCampus.map((item) => ({
                label: item.campusName,
                value: item.unid,
              })),
              caid: res.body.data.caid.split(","),
            };
          }
          this.loading = false;
        })
        .catch(() => {
          this.$util.errorMsg("请重试");
          this.loading = false;
        });
    },
    apiGetALLSchool() {
      this.$http({
        url: this.$util.domain + "/adminapi/v1/basicTools/allCampusZones",
        method: "GET",
      })
        .then((res) => {
          if (res.body.data && res.body.data.length) {
            this.schoolDataSource = res.body.data.map((item) => ({
              label: item.name,
              value: item.unid,
            }));
          } else {
            this.schoolDataSource = [];
          }
        })
        .catch((error) => {
          this.schoolDataSource = [];
        });
    },
    onAddSchools() {
      const datad = this.ruleForm.smsCampus.find((item) => {
        return item.value === this.schoolData;
      });
      if (datad && JSON.stringify(datad) !== "{}") {
        this.schoolData = null;
        return;
      }
      const data = this.schoolDataSource.find((item) => {
        return item.value === this.schoolData;
      });
      if (data && JSON.stringify(data) !== "{}") {
        this.ruleForm.smsCampus = [...this.ruleForm.smsCampus, data];
        this.schoolData = "";
      }
    },
    onDelSchools(unid) {
      const index = this.ruleForm.smsCampus
        .map((item) => item.value)
        .indexOf(unid);
      this.ruleForm.smsCampus.splice(index, 1);
    },
    apiGetStudentNumber(params) {
      this.loading = true;
      this.$http({
        url: this.$util.domain + "/adminapi/v1/sms/getStudentNumber",
        method: "POST",
        dataType: "json",
        body: JSON.stringify({
          ...params,
        }),
      })
        .then((res) => {
          if (res.body.data || res.body.data === 0) {
            this.ruleForm.studentNumber = res.body.data;
          } else {
            this.$util.errorMsg(res.body.message);
          }
          this.loading = false;
        })
        .catch(() => {
          this.$util.errorMsg("请重试");
          this.loading = false;
        });
    },
    submitForm() {
      this.$refs.ruleFormRef.validate((valid) => {
        if (valid) {
          this.loading = true;
          const params = {
            ...this.ruleForm,
            caid:
              this.ruleForm.caid && this.ruleForm.caid.length
                ? this.ruleForm.caid.join(",")
                : "",
            smsCampus: this.ruleForm.smsCampus.map((item) => ({
              campusName: item.label,
              unid: item.value,
              relateState: this.ruleForm.applicableCampus,
            })),
          };
          this.$http({
            url: this.$util.domain + "/adminapi/v1/sms/addConfig",
            method: "POST",
            dataType: "json",
            body: JSON.stringify({
              ...params,
            }),
          })
            .then((res) => {
              if (res.body.error === 10000) {
                this.$router.go(-1);
              } else {
                this.$util.errorMsg(res.body.message);
              }
              this.loading = false;
            })
            .catch(() => {
              this.$util.errorMsg("请重试");
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.SMS-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  background-color: #eee;
  font-size: 16px;
  padding: 0 30px;
  margin: 20px 0;
}
.SMS-main {
  box-sizing: border-box;
  width: 640px;
  padding: 0 30px;
}
.card-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 200px;
  overflow: auto;
  padding: 10px;
  margin: 8px 0 4px;
  border: 1px solid #c0ccda;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.5;
}
.card-footer {
  text-align: right;
  font-size: 14px;
  line-height: 1.5;
}
.dialog-item {
  display: inline-block;
  margin: 0 4px 4px;
  padding: 4px;
  border: 1px solid #c0ccda;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// index.vue?39521b8d